import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const LookupVouchersTemplateSchemas = zod.object({
    voucherName: zod.string().optional().nullable(),
})

export type ListVouchersTemplateDataTypes = zod.infer<
    typeof LookupVouchersTemplateSchemas
>

export const LookupVouchersSchemas = zod.object({
    voucherId: zod.number().optional().nullable(),
    voucherCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional().nullable(),
    voucherTypeId: zod.number().optional().nullable(),
    productSkus: zod.string().optional().nullable(),
    startDate: zod.string().optional().nullable(),
    pSize: zod.number().optional().nullable(),
    pNumber: zod.number().optional().nullable(),
})

export type ListVouchersDataTypes = zod.infer<
    typeof LookupVouchersSchemas
>

export const VoucherParamsSchemas = zod.object({
})

export const CampaignsDefaultSchemas = DefaultSchemas

export const CampaignComponentsDataSchemas = zod.object({
    componentId: zod.number(),
    campaignId: zod.number(),
    entityTypeId: zod.number().nullable(),
    entityTypeName: zod.string().nullable(),
    entityId: zod.number().nullable(),
    externalName: zod.string().nullable(),
    externalKey: zod.string().nullable(),
    parentComponentId: zod.number().nullable(),
    componentDescription: zod.string().nullable(),
    startDate: zod.string().nullable(),
    endDate:zod.string().nullable(),
    componentName: zod.string().nullable(),
})

export const CampaignComponentsAPISchemas =
    CampaignsDefaultSchemas.merge(
        zod.object({
            data: zod.array(CampaignComponentsDataSchemas),
        })
    )

export type CampaignComponentsAPITypes = zod.infer<
    typeof CampaignComponentsAPISchemas
>

export const CampaignsDataSchemas = zod.object({
    campaignName: zod.string(),
    campaignId: zod.number(),
    campaignCode: zod.string().nullable(),
    externalReference: zod.string().nullable(),
    startDate: zod.string().nullable(),
    endDate:zod.string().nullable(),
    description: zod.string().nullable(),
    statusId: zod.number(),
})

export const CampaignsAPISchemas =
    CampaignsDefaultSchemas.merge(
        zod.object({
            data: zod.array(CampaignsDataSchemas),
        })
    )

export type CampaignsAPITypes = zod.infer<
    typeof CampaignsAPISchemas
>
export type CampaignsDataTypes = zod.infer<
    typeof CampaignsDataSchemas
>

export const CampaignCreateFormSchemas = zod.object({
    campaignName: zod.string().min(1, { message: 'This field is required.' }),
    campaignCode: zod.string().min(1, { message: 'This field is required.' }),
    externalReference: zod.string().min(1, { message: 'This field is required.' }),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    description: zod.string().optional(),
    statusId: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    programUserId: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    flCommit: zod.number().optional().nullable(),
})

export interface CampaignCreationTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
    data: {
        campaignId: number
    }
}

export const CampaignUpdateFormSchemas = zod.object({
    campaignId: zod.number(),
    campaignName: zod.string().optional().nullable(),
    campaignCode: zod.string().optional().nullable(),
    externalReference: zod.string().optional().nullable(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    description: zod.string().optional().nullable(),
    statusId: zod.number().optional().nullable()
})

export interface CampaignUpdateTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
}

export const VouchersDefaultSchemas = DefaultSchemas

export const VouchersTemplateDataSchemas = zod.object({
    mcaId: zod.number(),
    mcaCampaignName: zod.string().optional().nullable(),
    voucherTypeId: zod.number().optional().nullable(),
    voucherIssuerId: zod.number(),
    voucherIssuerName: zod.string().optional().nullable(),
    voucherDescription: zod.string().optional().nullable(),
    voucherDuration: zod.number().optional().nullable(),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string(),
    voucherValue: zod.number(),
    sku: zod.string().optional().nullable(),
    imageUrl: zod.string().optional().nullable(),
    offerTypeId: zod.number().optional().nullable(),
    offerValue2: zod.number().optional().nullable(),
    offerValue3: zod.number().optional().nullable(),
    offerId: zod.number().optional().nullable(),
    endDate: zod.string().optional().nullable(),
})

export const VouchersTemplateAPISchemas =
    VouchersDefaultSchemas.merge(
        zod.object({
            data: zod.array(VouchersTemplateDataSchemas),
        })
    )

export type VouchersTemplateAPITypes = zod.infer<
    typeof VouchersTemplateAPISchemas
>
export type VouchersTemplateDataTypes = zod.infer<
    typeof VouchersTemplateDataSchemas
>

export const VouchersDataSchemas = zod.object({
    voucherId: zod.number(),
    voucherCode: zod.string(),
    voucherTypeId: zod.number(),
    voucherTypeDescription: zod.string().optional().nullable(),
    mcaId: zod.number().nullable(),
    mcaName: zod.string().optional(),
    voucherIssuerId: zod.number(),
    voucherIssuerName: zod.string().optional(),
    voucherName: zod.string(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    voucherValue: zod.number(),
    securityCode: zod.number().optional().nullable(),
    startDate: zod.string().optional(),
    endDate: zod.string().optional(),
    offerTypeId: zod.number().optional(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    merchants: zod.string().array().optional().nullable(),
    pluCode: zod.string().optional(),
    productSkus: zod.string().array().optional().nullable(),
    offerId: zod.number().optional().nullable(),
})

export const VoucherListTableSchemas = zod.object({
    tableData: VouchersDataSchemas.array()
})

export const VouchersAPISchemas =
    VouchersDefaultSchemas.merge(
        zod.object({
            data: zod.array(VouchersDataSchemas),
        })
    )

export type VouchersAPITypes = zod.infer<
    typeof VouchersAPISchemas
>
export type VouchersDataTypes = zod.infer<
    typeof VouchersDataSchemas
>

export const CSVoucherCreateFormSchemas = zod.object({
    voucherTypeId: zod.number(),
    voucherIssuerId: zod.number(),
    voucherIssuerName: zod.string(),
    voucherValue: zod.number(),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    voucherCount: zod.number().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    flSecurityCode: zod.number().optional().nullable(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    mcaId: zod.number().optional().nullable(),
    offerId: zod.number().optional().nullable(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    offerTypeId: zod.number().optional().nullable(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
    mca: zod.string().optional().nullable(), //not passing this to API
    voucherIssuer: zod.string(), //not passing this to API
})

export interface CSVoucherCreationTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
    data: {
        voucherId: number
        voucherCode: string
    }
}

export const VoucherCreateFormSchemas = zod.object({
    voucherTypeId: zod.number().min(1, { message: 'This field is required.' }),
    voucherIssuerId: zod.number().min(1, { message: 'This field is required.' }),
    voucherValue: zod.number({
        required_error: 'This field is required.',
        invalid_type_error: 'This field is required.',
    }),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    voucherCount: zod.number().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    flSecurityCode: zod.number().optional().nullable(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    mcaId: zod.number().optional().nullable(),
    offerId: zod.number().optional().nullable(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    offerTypeId: zod.number().optional().nullable(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
})

export interface VoucherCreationTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
    data: {
        voucherId: number
        voucherCode: string
    }
}

export const VoucherViewFormSchemas = zod.object({
    voucherId: zod.number(),
    voucherCode: zod.string(),
    voucherTypeId: zod.number(),
    voucherIssuer: zod.string(),
    voucherValue: zod.number(),
    pluCode: zod.string().optional().nullable(),
    voucherName: zod.string().optional(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    voucherCount: zod.number().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    flSecurityCode: zod.number().optional().nullable(),
    description: zod.string().optional(),
    imageUrl: zod.string().optional(),
    mca: zod.string().optional().nullable(),
    offerId: zod.number().optional().nullable(),
    offerValue2: zod.number().optional(),
    offerValue3: zod.number().optional(),
    offerTypeId: zod.number().optional(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(),
})

export const VoucherUpdateFormSchemas = zod.object({
    voucherId: zod.number(),
    voucherCode: zod.string(),
    voucherTypeId: zod.number(),
    voucherValue: zod.number().optional().nullable(),
    voucherName: zod.string().optional().nullable(),
    startDate: zod.string().optional().nullable(),
    endDate: zod.string().optional().nullable(),
    references: zod.string().array().optional(),
    description: zod.string().optional().nullable(),
    imageUrl: zod.string().optional().nullable(),
    offerId: zod.number().optional().nullable(),
    offerValue2: zod.number().optional().nullable(),
    offerValue3: zod.number().optional().nullable(),
    offerTypeId: zod.number().optional().nullable(),
    pluCode: zod.string().optional().nullable(),
    merchants: zod.string().array().optional().nullable(),
    productSkus: zod.string().array().optional().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
})

export interface VoucherUpdateTypes {
    outcomeCode: string
    outcomeMessage: string
    outcomeUserMessage: string
}

export const VoucherAPISchemas = DefaultSchemas.merge(zod.object({
    data: VouchersDataSchemas.array()
}));

export type CampaignCreateFormTypes = zod.infer<typeof CampaignCreateFormSchemas>;
export type CampaignUpdateFormTypes = zod.infer<typeof CampaignUpdateFormSchemas>;
export type CSVoucherCreateFormTypes = zod.infer<typeof CSVoucherCreateFormSchemas>;
export type VoucherCreateFormTypes = zod.infer<typeof VoucherCreateFormSchemas>;
export type VoucherViewFormTypes = zod.infer<typeof VoucherViewFormSchemas>;
export type VoucherUpdateFormTypes = zod.infer<typeof VoucherUpdateFormSchemas>;
export type VoucherListTableTypes = zod.infer<typeof VoucherListTableSchemas>;
export type VoucherParamsTypes = zod.infer<typeof VoucherParamsSchemas>;
export type VoucherDataTypes = zod.infer<typeof LookupVouchersSchemas>;
export type VoucherAPITypes = zod.infer<typeof VoucherAPISchemas>;